import type { Policy } from '@cartwhl/common/appletPolicy';

import StudioShellLayout from '../StudioShellLayout';
import BatchComic from './components/BatchComic';

const applet = {
  id: 'comic',
  path: '/comic',
  paths: ['/comic', '/comic/:id', '/batch-comic', '/batch-comic/:id'],
  label: 'Comic',
  description: 'AI motion capture',
  dashboard: {
    imageSrc:
      'https://resources.getcartwheel.com/share/demo-videos/comic-thumb.jpg',
    imageAlt: '',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/app_launcher_comic.webm',
    title: 'Comic',
    description:
      'Video-to-motion. Capture motion from people, faces and cameras.',
    order: 10,
  },
  policy: {
    requiresLoggedIn: true,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: BatchComic,
  layout: StudioShellLayout,
};

export default applet;
